import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';
import cookie from 'react-cookies';

export const brandApi = createApi({
  reducerPath: 'brandApi',
  baseQuery: createBaseQuery('brands'),
  endpoints: builder => ({
    getBrand: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useLazyGetBrandQuery } = brandApi;
